import { AppEffects } from '../app/app.effects';

import { SettingsUsersEffects } from '../settings/users/users.effects';
import { SettingsGroupsEffects } from '../settings/groups/groups.effects';
import { SettingsRulesEffects } from '../settings/rules/rules.effects';
import { SettingsWorkflowsEffects } from '../settings/workflows/workflows.effects';
import { SettingsCustomFormsEffects } from '../settings/custom-forms/custom-forms.effects';
import { SettingsOrganizationEffects } from '../settings/organization/organization.effects';
import { ProjectsEffects } from '../projects/projects.effects';
import { ProjectsCustomFormsEffects } from '../projects/custom-forms/projects-custom-forms.effects';
import { LabelsEffects } from '../labels/labels.effects';
import { VersionsEffects } from '../versions/versions.effects';
import { LibraryEffects } from '../library/library.effects';
import { DashboardEffects } from '../dashboard/dashboard.effects';
import { ApprovalsEffects } from '../approvals/approvals.effects';
import { AIEffects } from '../ai/ai.effects';
import { AddProjectEffects } from '../add-project/add-project.effects';
import { AddVersionEffects } from '../add-version/add-version.effects';

// form Core
import { RecorderEffects } from '@core/store/state/recorder/recorder.effects';
import { CustomFormsEffects } from '@core/store/state/custom-forms/custom-forms.effects';
import { ProjectRelatedVersionsEffects } from '@core/store/state/project-related-versions/project-related-versions.effects';

export const rootEffects = [
    AppEffects,
    SettingsUsersEffects,
    SettingsGroupsEffects,
    SettingsRulesEffects,
    SettingsWorkflowsEffects,
    SettingsCustomFormsEffects,
    SettingsOrganizationEffects,
    ProjectsEffects,
    ProjectsCustomFormsEffects,
    VersionsEffects,
    LabelsEffects,
    LibraryEffects,
    DashboardEffects,
    ApprovalsEffects,
    AIEffects,
    AddProjectEffects,
    AddVersionEffects,
    RecorderEffects,
    CustomFormsEffects,
    // ProjectRelatedVersionsEffects
]